<div class="w-100 h-100 d-flex align-items-center justify-content-center">
  @if (isLoading) {
  <fa-icon
    [icon]="['fas', 'spinner']"
    [spin]="true"
    [pulse]="true"
    class="mr-3"
  ></fa-icon>
  <span i18n="@@loadingProduct">Loading product...</span>
  } @else { @if (product) {
  <atx-product-card
    [prices]="product.priceRanges ?? []"
    [product]="product"
    [showActions]="false"
    (cardClick)="onClick(product)"
  >
  </atx-product-card>
  } @else {
  <span i18n="@@productNotFound"></span>Product not found }
  <ng-template #productNotFound
    ><span i18n="@@productNotFound"></span>Product not found</ng-template
  >
  }
</div>
